import styled from 'styled-components';
import { rem } from 'polished';

const baseFont = '12px';
const S = {};

const FwSemibold = ({theme:{$fwSemibold}}) => `${$fwSemibold}`;
const FwRegular = ({theme:{$fwRegular}}) => `${$fwRegular}`;

const InputErrorColor = ({theme: {$inputErrorColor}}) => `${$inputErrorColor}`;
const InputColor = ({theme: {$inputColor}}) => `${$inputColor}`;
const InputLabelColor = ({theme: {$inputLabelColor}}) => `${$inputLabelColor}`;
const InputPlaceholderColor = ({theme: {$inputPlaceholderColor}}) => `${$inputPlaceholderColor}`;
const InputBackgroundColor = ({theme: {$inputBackgroundColor}}) => `${$inputBackgroundColor}`;
const SubmitButtonTextColor = ({theme: {$submitButtonTextColor}}) => `${$submitButtonTextColor}`;
const FooterTextColor = ({theme: {$footerTextColor}}) => `${$footerTextColor}`;
const CheckedCheckboxColor = ({theme: {$checkedCheckboxColor}}) => `${$checkedCheckboxColor}`;
const CheckboxBorderColor = ({theme: {$checkboxBorderColor}}) => `${$checkboxBorderColor}`;
const CheckboxBackgroundColor = ({theme: {$checkboxBackgroundColor}}) => `${$checkboxBackgroundColor}`;
const LabelTextColor = ({theme: {$labelTextColor}}) => `${$labelTextColor}`;
const DropdownArrowColor = ({theme: {$dropdownArrowColor}}) => `${$dropdownArrowColor}`;

S.FormStep2 = styled.form`
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

S.FieldsGrid = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: ${rem('16px')};
    margin-bottom: ${rem('20px')};
`;

S.InputWrapper = styled.div`
    position: relative;
    width: 100%;
    grid-column: ${props => props.fullWidth ? '1 / span 2' : 'auto'};
`;

S.Input = styled.input`
    width: 100%;
    box-sizing: border-box;
    height: ${rem('40px')};
    padding: 0 ${rem('12px')};
    border-radius: 4px;
    font-size: ${rem('14px')};
    background: ${InputBackgroundColor};
    transition: border-color 0.2s;

    border: 1px solid ${props => props.hasError ? InputErrorColor : InputColor};

    &:focus {
        outline: none;
        border-color: ${props => props.hasError ? InputErrorColor : InputColor};
    }

    &:disabled {
        color: ${InputPlaceholderColor};
        cursor: not-allowed;
        border-color: ${InputColor};
    }

    &::placeholder {
        color: ${InputPlaceholderColor};
    }
`;

S.FloatingLabel = styled.span`
    position: absolute;
    top: -8px;
    left: 12px;
    background: ${InputBackgroundColor};
    padding: 0 4px;
    font-size: ${rem('10px')};
    color: ${InputLabelColor};
`;

S.CheckIcon = styled.span`
    color: ${InputLabelColor};
    font-size: ${rem('16px')};
    pointer-events: none;
`;

S.CheckboxesSection = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${rem('16px')};
    margin-bottom: ${rem('24px')};
`;

S.CheckboxWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${rem('12px')};
    font-weight: ${FwRegular};
`;

S.HiddenInput = styled.input`
    position: absolute;
    opacity: 0;
    height: 0;
`;

S.FakeCheckbox = styled.label`
    width: 18px;
    height: 18px;
    border: 1px solid ${props => props.checked ? CheckedCheckboxColor : CheckboxBorderColor};
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${CheckboxBackgroundColor};
    border-radius: 2px;
    flex-shrink: 0;
    margin-right: 10px;
`;

S.CheckMark = styled.span`
    font-size: 14px;
    color: ${CheckedCheckboxColor};
`;

S.SelectLabel = styled.span`
    font-size: 14px;
    color: ${LabelTextColor};
`;

S.SowWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
`;

S.Label = styled.label`
    font-size: ${rem('11px')};
    line-height: 1.4;
    color: ${LabelTextColor};
    cursor: pointer;
    font-weight: ${FwRegular};
`;

S.SourceSection = styled.div`
    width: 100%;
    margin-bottom: ${rem('24px')};
`;

S.SourceTitle = styled.div` 
    font-weight: ${FwSemibold}; 
    font-size: ${rem('14px')}; 
    color: ${LabelTextColor}; 
`;

S.SourceInfo = styled.div` 
    font-size: ${rem('12px')}; 
    color: ${LabelTextColor};
    margin-top: 4px; 
`;

S.DropdownContainer = styled.div`
    position: relative;
    width: 100%;
    margin-top: ${rem('8px')};
`;

S.DropdownHeader = styled.div`
    width: 100%;
    height: ${rem('40px')};
    border: 1px solid ${props => 
        props.hasError ? InputErrorColor : (props.isOpen ? CheckedCheckboxColor : CheckboxBorderColor)
    };
    border-radius: 4px;
    padding: 0 ${rem('12px')};
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${InputBackgroundColor};
    cursor: pointer;
    font-size: ${rem('14px')};
    color: ${props => props.hasValue ? LabelTextColor : InputPlaceholderColor};
`;

S.DropdownList = styled.div`
    position: absolute;
    top: 100%; left: 0;
    width: 100%;
    max-height: ${rem('200px')};
    overflow-y: auto;
    background: ${InputBackgroundColor};
    border: 1px solid ${CheckedCheckboxColor};
    border-top: none;
    z-index: 10;
    padding: ${rem('12px')};
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
`;

S.Arrow = styled.span`
    border: solid ${DropdownArrowColor};
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: ${props => props.isOpen ? 'rotate(-135deg)' : 'rotate(45deg)'};
    transition: transform 0.2s;
`;

S.SubmitBtn = styled.button`
    width: 100%;
    height: ${rem('40px')};
    font-size: ${rem('14px')};
    background-color: ${InputErrorColor};
    color: ${SubmitButtonTextColor};
    border: none;
    border-radius: 3px;
    font-weight: ${FwSemibold};
    cursor: pointer;
    text-transform: uppercase;
    margin: ${rem('20px')} auto;

    &:disabled { 
        opacity: 0.6; 
        cursor: not-allowed; 
    }
`;

S.FooterInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem('4px')};
    margin-top: ${rem('24px')};
    text-align: center;
`;

S.ContactInfo = styled.div`
    font-size: ${rem('12px')};
    color: ${FooterTextColor};
`;

S.ContactLink = styled.span`
    color: ${InputErrorColor};
    font-weight: ${FwSemibold};
    font-size: ${rem('12px')};
    cursor: pointer;
`;

S.ErrorText = styled.div` 
    color: ${InputErrorColor};
    font-size: 10px; 
    margin-top: 2px; 
`;

export default S;